import { getLocale } from "../runtime";

const sv_notifyformtitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Få en notis när produkten är tillbaka`
};

const notifyformtitle = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_notifyformtitle(inputs)
	return "notifyFormTitle";
};

export { notifyformtitle as "notifyFormTitle" };